var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HeaderNavLink',_vm._g(_vm._b({staticClass:"header__nav-link--account",attrs:{"component":"button","type":"button","aria-label":"Account"}},'HeaderNavLink',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }